// Copyright (c) StrangeBee 2024

import { WarningTwoTone } from '@ant-design/icons';
import { HTMLColors } from '@Constants/colors';
import { THAutoComplete } from '@Molecules/Inputs/THAutoComplete/THAutoComplete';
import { Space } from 'antd';
import React, { ReactElement, useEffect, useMemo, useState } from 'react';
import { DescribeFieldOutput } from 'thehive-sdk';

interface FiltersAttributesProps {
    describeField?: DescribeFieldOutput;
    filter?: any;
    onChange?: (value: string) => void;
    aggregationWarning?: boolean;
}

const FiltersAttributes = ({
    describeField,
    filter,
    onChange,
    aggregationWarning = false,
}: FiltersAttributesProps): ReactElement => {
    const [value, setValue] = useState(filter?.field);

    const attributesOptions = useMemo(
        () =>
            describeField?.attributes
                .sort(({ name: nameA }, { name: nameB }) => nameA.localeCompare(nameB))
                .map(({ name, indexType }) => ({
                    label: aggregationWarning
                        ? indexType === 'none' && (
                              <Space>
                                  <span>{<WarningTwoTone twoToneColor={HTMLColors.RED} />}</span>
                                  {name}
                              </Space>
                          )
                        : name,
                    value: name,
                })),
        [describeField?.attributes, aggregationWarning],
    );

    useEffect(() => {
        setValue(filter.field || '');
    }, [filter.field]);

    return (
        <div className="field">
            <THAutoComplete
                filtered
                showSearch
                options={attributesOptions}
                value={value}
                onChange={(value) => {
                    setValue(value);
                    onChange?.(value);
                }}
                className="input-full-width"
            />
        </div>
    );
};

export default FiltersAttributes;
